export default "__VITE_ASSET__3a4487bb__"